<template>
    <div class="pagination">
        <button class="green-btn" :disabled="isPreviousButtonDisabled()" @click="loadPage(1)"><font-awesome-icon icon="step-backward" /></button>
        <button class="green-btn" :class="{'active':(currentPage === nb)}" v-for="nb of getNumbers" :key="nb" @click="loadPage(nb)">{{ nb }}</button>
        <button class="green-btn" :disabled="isNextButtonDisabled()" @click="loadPage(pageCount)"><font-awesome-icon icon="step-forward" /></button>
    </div>
</template>

<script>
export default {
    name: "BrandPagination",
    static: {
        choiceNumberDigits : 5
    },
    props: {
        currentPage: Number,
        pageCount: Number,
    },
    created() {
        this.getNumbers
    },
    computed: {
        getNumbers(){
            if (this.pageCount < this.$options.static.choiceNumberDigits){
                return Array.from(Array(this.pageCount), (_, i) => i + 1)
            }
            let margin = Math.ceil(this.$options.static.choiceNumberDigits/2)
            if(this.currentPage <= margin){
                return  Array.from(Array(this.$options.static.choiceNumberDigits), (_, i) => i + 1)
            }else if(this.pageCount - this.currentPage <=  margin -1) {
                return Array.from(Array(this.$options.static.choiceNumberDigits), (_, i) => i + this.pageCount - this.$options.static.choiceNumberDigits + 1)
            }
            return Array.from(Array(this.$options.static.choiceNumberDigits), (_, i) => i + this.currentPage - margin + 1)
        },
    },
    methods: {
        loadPage(value) {
            this.$emit("loadPage", value);
        },
        isPreviousButtonDisabled() {
            return this.currentPage === 1;
        },
        isNextButtonDisabled() {
            return this.currentPage === this.pageCount;
        }
    }
}
</script>

<style scoped lang="scss">

.pagination{
    display: flex;
    justify-content: center;
    margin-bottom: 20px;

    &:last-of-type{
        margin-top: 20px;
    }

    .green-btn {
        font-size: 12px;
        width: 30px;
        height: 30px;
        margin: 0 5px;
        border-radius: 50%;

        &.active{
            opacity: 0.8 ;
        }
    }
}

</style>